import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PrivateLibraryService } from 'src/app/core/services/private-library.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { AdditionalPublicLibraryService } from 'src/app/core/services/additional-public-library.service';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { environment } from 'src/environments/environment';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';

@Component({
  selector: 'app-distribute-content',
  templateUrl: './distribute-content.component.html',
  styleUrls: ['./distribute-content.component.scss']
})
export class DistributeContentComponent implements OnInit {

  @Input() public content;
  @Input() public isPublish;
  @Input() public liabrary_type;
  @Input() public addOnInActive;
  assignpublishswitch: boolean = true;
  distributeForm: FormGroup;
  submitted: boolean = false;
  dropdownLibraries = {
    singleSelection: true,
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class form-control",
    text: 'Please select additional public library',
    labelKey: "business_name",
    noDataLabel: "No additional public library found",
    searchBy: ['business_name']
  };
  selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
  additionalLibraries = [];
  currentUser;
  imagePath = environment.url;
  maxClicks = 0;
  isCopy: boolean = false;
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private modalService: NgbModal,
    private additonalService: AdditionalPublicLibraryService,
  ) { }

  ngOnInit() {
    // if(this.addOnInActive){
    //   this.assignpublishswitch = false;
    //   this.additionalAddonExpired();
    // }
    this.listAdditionalLibraries();
    this.currentUser = this.authService.getCurrentUser();
    if (this.content.content_relationship && this.currentUser && this.currentUser.user.id == this.content.user_id) {
      this.maxClicks = this.content.content_relationship.no_of_clicks;
    } else if (this.content.content_relationship) {
      this.isCopy = true;
      this.maxClicks = this.content.content_relationship.no_of_copies;
    }

    this.distributeForm = this.formBuilder.group({
      library: ['', Validators.required],
      assign_no_of_content_copies: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.INTEGER_PATTERN), Validators.min(0), Validators.max(this.maxClicks)])],
    });
    if (this.content.tokens == 0) {
      this.distributeForm.controls.assign_no_of_content_copies.clearValidators();
      this.distributeForm.controls.assign_no_of_content_copies.updateValueAndValidity();
    }
  }

  closeDialog() {
    this.activeModal.close();
  }

  inputChange(){
    // if(this.addOnInActive && this.assignpublishswitch){
    //   this.additionalAddonExpired();
    // }
  }

  onSubmit() {
    this.submitted = true;
    if (!this.distributeForm.valid) {
      return;
    }
    if(this.addOnInActive){
      // this.assignpublishswitch = false;
      this.additionalAddonExpired();
      return;
    }
    let obj = {
      content_id: this.content.id,
      user_outlet_id: this.distributeForm.controls.library.value[0].id,
      liabrary_type: this.liabrary_type
    }
    if (this.isCopy) {
      obj['assign_no_of_content_copies'] = this.distributeForm.controls.assign_no_of_content_copies.value;
    } else {
      obj['assign_no_of_clicks'] = this.distributeForm.controls.assign_no_of_content_copies.value;
    }
    this.spinner.show();
    this.additonalService.assignContentToOutlet(obj).subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
        if (this.content.tokens == 0) {
          modalRef.componentInstance.message = this.content.out_line + ' has been assigned to ' + this.distributeForm.controls.library.value[0].business_name + ' successfully.';
        } else {
          if (this.isCopy) {
            if (this.distributeForm.controls.assign_no_of_content_copies.value <= 1) {
              modalRef.componentInstance.message = this.distributeForm.controls.assign_no_of_content_copies.value + ' copy of ' + this.content.out_line + ' has been assigned to ' + this.distributeForm.controls.library.value[0].business_name + ' successfully.';
            } else {
              modalRef.componentInstance.message = this.distributeForm.controls.assign_no_of_content_copies.value + ' copies of ' + this.content.out_line + ' has been assigned to ' + this.distributeForm.controls.library.value[0].business_name + ' successfully.';
            }
          } else {
            if (this.distributeForm.controls.assign_no_of_content_copies.value <= 1) {
              modalRef.componentInstance.message =  this.distributeForm.controls.assign_no_of_content_copies.value + ' click of ' + this.content.out_line + ' has been assigned to ' + this.distributeForm.controls.library.value[0].business_name + ' successfully.';
            } else {
              modalRef.componentInstance.message = this.distributeForm.controls.assign_no_of_content_copies.value + ' clicks of ' + this.content.out_line + ' has been assigned to ' + this.distributeForm.controls.library.value[0].business_name + ' successfully.';
            }

          }
        }

        this.activeModal.close('assign');
      } else if (response.errors) {
        const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
        modalRef.componentInstance.contentAccessError = response.errors;
    modalRef.componentInstance.isRedirectRequired = false;
      } else {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.OUTLET_CONTENT_ASSIGN_ERROR;
      }
    }, (error) => {
      const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
      modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.OUTLET_CONTENT_ASSIGN_ERROR;
      this.spinner.hide();
    });
  }

  publish() {
    this.activeModal.close('publish');
  }

  onSelectConnection(item) {
    if (item) {
      if (item.avatar) {
        this.selectedUserImage = this.imagePath + item.avatar;
      } else {
        this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
      }
    }
    else {
      this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    }
  }
  OnConnectionDeselect(event) {
    this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
  }

  restrictNumeric(event) {
    //firefox solution
    event = event || window.event;
    var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      event.preventDefault();
    const restrictKeycodes = [101, 46, 43, 45];
    if (restrictKeycodes.includes(event.keyCode) || event.target.value.length > 11) {
      return false;
    }
  }

  restrictNumericPaste(event) {
    let text = event.clipboardData.getData('text').toString();
    let filteredText = text.replace(REGEX_PATTERNS.NUMBER_REMOVE, "");
    let copies = (this.distributeForm.get('assign_no_of_content_copies').value) ? (this.distributeForm.get('assign_no_of_content_copies').value.toString() + filteredText) : filteredText;
    
    this.distributeForm.patchValue({
      assign_no_of_content_copies: copies.substring(0, 12)
    });    
    event.preventDefault();
  }

  listAdditionalLibraries() {
    this.spinner.show();
    this.additonalService.listIndividualOutlets().subscribe((response) => {
      this.spinner.hide();
      if (response.success) {
        this.additionalLibraries = response.data.user_outlets;
      }
    }, (error) => {
      this.spinner.hide();
    });
  }

  additionalAddonExpired() {
    const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
    modalRef.componentInstance.contentAccessError = LITERALS.AUTH.ERROR_MESSAGES.ADDITIOAL_PUBLIC_LIBRARY_ADDON_EXPIRED_ASSIGN;
    modalRef.componentInstance.isRedirectRequired = false;
    // modalRef.result.then((response)=>{
    //   this.assignpublishswitch = false;
    // },(reason)=>{
    //   this.assignpublishswitch = false;
    // });
  }
}
